import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguagePicker } from './LanguagePicker';
import { BrandLockup } from './BrandLogo';

/**
 * Public marketing header. Replaces the old LandingHeader. CTA buttons
 * point at the in-app /login + /signup routes (no cross-origin OAuth
 * jump from a marketing button).
 */
export function SiteHeader() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navItem = (path: string) =>
    'transition-colors ' +
    (pathname === path ? 'text-foreground' : 'text-muted-foreground hover:text-foreground');

  return (
    <header className="sticky top-0 z-40 bg-background/85 backdrop-blur border-b border-border">
      <div className="max-w-7xl mx-auto h-16 px-6 flex items-center justify-between">
        <BrandLockup to="/" />
        <nav className="hidden md:flex items-center gap-7 text-sm">
          <Link to="/pricing" className={navItem('/pricing')}>{t('nav.pricing')}</Link>
          <Link to="/compare" className={navItem('/compare')}>{t('nav.compare')}</Link>
          <Link to="/security" className={navItem('/security')}>{t('nav.security')}</Link>
          <Link to="/demo" className={navItem('/demo')}>{t('nav.demo')}</Link>
        </nav>
        <div className="flex items-center gap-3">
          <LanguagePicker compact />
          <Link
            to="/login"
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {t('nav.login')}
          </Link>
          <Link
            to="/signup"
            className="inline-flex items-center justify-center gap-2 rounded-lg font-medium h-9 px-4 text-sm bg-foreground text-background hover:bg-foreground/90 transition-colors"
          >
            {t('nav.signUp')}
          </Link>
        </div>
      </div>
    </header>
  );
}
